import React, { useState, useEffect } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { JCBCardIcon } from "../../components/Icons/JCBCardIcon";
import { VisaCardNewIcon } from "../../components/Icons/VisaCardNewIcon";
import { MasterCardIcon } from "../../components/Icons/MasterCardIcon";
import { CartIconDefault } from "../../components/Icons/CartIconDefault";
import { AmexCardIcon } from "../../components/Icons/AmexCardIcon";
import { DiscoverCardIcon } from "../../components/Icons/DiscoverCardIcon";
import { DinersCardIcon } from "../../components/Icons/DinersCardIcon";
import "react-credit-cards/es/styles-compiled.css";
import * as Notification from "../../Notification";
import { ssoGetUserInfo, ssoUpdateProfile } from "../../services/app";
import { WalletDetailNotify } from "../../components/ItemSubscription/ModalUpdateCard";
import { ModalTermAndCondition } from "./components/modalTermAndCondition";
import { ModalTermAndConditionAirwallex } from "./components/ModalTermAndConditionAirwallex";
import { createCardUpdaturl, get3dsCard } from "../../services/payment";
import { ModalFeatureNotAvailable } from "./components/modalFeatureNotAvailable";

export const PaymentMethod = () => {
  const { T, user, setLoading } = useApp();
  const [cardList, setCardList] = useState([]);

  useEffect(() => {
    loadCardList();
  }, []);

  const loadCardList = async () => {
    setLoading(true);
    try {
      const res = await get3dsCard({
        email: user.email,
        shop: new URL(user.store_shopify).hostname,
      });
      if (res?.data?.data) {
        setCardList([res?.data?.data]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPayment = () => {
    handleUpdateCardCredix();
  };

  const getCardIcon = (card) => {
    switch (card.card_type) {
      case "VISA":
        return <VisaCardNewIcon />;
      case "AMEX":
        return <AmexCardIcon />;
      case "MASTERCARD":
        return <MasterCardIcon />;
      case "DISCOVER":
        return <DiscoverCardIcon />;
      case "DINERS":
        return <DinersCardIcon />;
      case "JCB":
        return <JCBCardIcon />;
      default:
        return <CartIconDefault />;
    }
  };
  const trimSpace = (str) => {
    if (!str || str.length === 0) return "";
    return str.replaceAll(" ", "");
  };

  const handleUpdateCardCredix = async () => {
    const isStoreJp = await IsUserOfStoreJp();
    if (isStoreJp) {
      const res = await get3dsCard({
        email: user.email,
        shop: new URL(user.store_shopify).hostname,
      });
      if (res?.data?.data?.payment_method === 'airwallex') {
        const isAgreeTermAndCondition = await loadIsAgreeTermAndConditionAirwallex();
        if (!isAgreeTermAndCondition) {
          showModalConfirmTermAndConditionAirwallex();
        } else {
          redirectToCredix();
        }
      } else {
        const isAgreeTermAndCondition = await loadIsAgreeTermAndConditionCredix();
        if (!isAgreeTermAndCondition) {
          showModalConfirmTermAndConditionCredix();
        } else {
          redirectToCredix();
        }
      }
    }
  };

  const [isShowModalFeatureNotAvailable, setIsShowModalFeatureNotAvailable] =
    useState(false);

  const IsUserOfStoreJp = async () => {
    try {
      const isOfStore = user.acceptedCredixPayment;
      if (!isOfStore) {
        setIsShowModalFeatureNotAvailable(true);
      }
      return isOfStore;
    } catch (error) {
      console.error(error);
      Notification.error(T("Some error happened. Please try again later."));
      return false;
    }
  };

  const [
    isShowModalConfirmTermAndConditionCredix,
    setIsShowModalConfirmTermAndConditionCredix,
  ] = useState(false);

  const [
    isShowModalConfirmTermAndConditionAirwallex,
    setIsShowModalConfirmTermAndConditionAirwallex,
  ] = useState(false);

  const [
    isLoadingAgreeTermAndConditionCredix,
    setIsLoadingAgreeTermAndConditionCredix,
  ] = useState(false);

  const [
    isLoadingAgreeTermAndConditionAirwallex,
    setIsLoadingAgreeTermAndConditionAirwallex,
  ] = useState(false);

  const loadIsAgreeTermAndConditionCredix = async () => {
    const res = await ssoGetUserInfo();
    const isAgree = res?.data?.data?.is_agree_credix_term === 1;
    return isAgree;
  };

  const loadIsAgreeTermAndConditionAirwallex = async () => {
    const res = await ssoGetUserInfo();
    const isAgree = res?.data?.data?.is_agree_airwallex_term === 1;
    return isAgree;
  };

  const updateAgreeTermAndConditionCredix = async () => {
    try {
      setIsLoadingAgreeTermAndConditionCredix(true);
      const res = await ssoUpdateProfile({
        is_agree_credix_term: 1,
      });
      if (res?.data?.status) {
        return true;
      } else {
        Notification.error(T("Some error happened. Please try again later."));
        return false;
      }
    } catch (error) {
      console.error(error);
      Notification.error(T("Some error happened. Please try again later."));
      return false;
    } finally {
      setIsLoadingAgreeTermAndConditionCredix(false);
    }
  };

  const updateAgreeTermAndConditionAirwallex = async () => {
    try {
      setIsLoadingAgreeTermAndConditionAirwallex(true);
      const res = await ssoUpdateProfile({
        is_agree_airwallex_term: 1,
      });
      if (res?.data?.status) {
        return true;
      } else {
        Notification.error(T("Some error happened. Please try again later."));
        return false;
      }
    } catch (error) {
      console.error(error);
      Notification.error(T("Some error happened. Please try again later."));
      return false;
    } finally {
      setIsLoadingAgreeTermAndConditionAirwallex(false);
    }
  };

  const showModalConfirmTermAndConditionCredix = () => {
    setIsShowModalConfirmTermAndConditionCredix(true);
  };

  const showModalConfirmTermAndConditionAirwallex = () => {
    setIsShowModalConfirmTermAndConditionAirwallex(true);
  };

  const redirectToCredix = async () => {
    try {
      setLoading(true);
      const res = await createCardUpdaturl({
        email: user.email,
        shop: new URL(user.store_shopify).hostname,
      });
      if (res?.data?.payment_url) {
        window.location.href = res.data.payment_url;
      } else {
        Notification.error(T("Some error happened. Please try again later."));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAgreeTermAndConditionCredix = async () => {
    const updateSuccess = await updateAgreeTermAndConditionCredix();
    if (updateSuccess) {
      setIsShowModalConfirmTermAndConditionCredix(false);
      redirectToCredix();
    }
  };

  const handleAgreeTermAndConditionAirwallex = async () => {
    const updateSuccess = await updateAgreeTermAndConditionAirwallex();
    if (updateSuccess) {
      setIsShowModalConfirmTermAndConditionAirwallex(false);
      redirectToCredix();
    }
  };

  return (
    <>
      <Container>
        <ContainerView background="transparent">
          <TitlePage>{T("Payment method")}</TitlePage>
          <div className="flex justify-center items-start w-full mx-auto  container mt-[32px] lg:gap-12">
            <div className="mt-[20px] lg:mt-[20px]">
              <div>
                <WalletDetailNotify style={{ marginRight: 0 }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_2694_81806)">
                      <path
                        d="M3.65031 2.9347C5.60075 0.977564 7.95887 0 10.7227 0C13.4864 0 15.8426 0.977564 17.795 2.9347C19.7474 4.89183 20.7227 7.24559 20.7227 10C20.7227 12.7544 19.7474 15.1102 17.795 17.0673C15.8426 19.0244 13.4864 20 10.7227 20C7.95887 20 5.60075 19.0224 3.65031 17.0673C1.69987 15.1122 0.722656 12.7544 0.722656 10C0.722656 7.24559 1.69788 4.88982 3.65031 2.9347ZM5.07917 15.6811C6.63992 17.2456 8.52042 18.0288 10.7227 18.0288C12.9249 18.0288 14.8054 17.2456 16.3661 15.6811C17.9269 14.1166 18.7083 12.2236 18.7083 10C18.7083 7.77644 17.9269 5.88542 16.3661 4.31891C14.8054 2.7524 12.9229 1.97115 10.7227 1.97115C8.52242 1.97115 6.63992 2.75441 5.07917 4.31891C3.51842 5.88341 2.73704 7.77845 2.73704 10C2.73704 12.2216 3.51642 14.1166 5.07917 15.6811ZM9.71546 6.99519V4.97596H11.7298V6.99519H9.71546ZM9.71546 15.024V9.01442H11.7298V15.024H9.71546Z"
                        fill="#606062"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2694_81806">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0.71875)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: T(
                        `Kindly note that the modification of card information will presently be applicable to Subscription.`
                      ),
                    }}
                  />
                </WalletDetailNotify>
                <div className="payment-list mt-[30px]">
                  <div className="text-[20px] text-black font-medium mb-2">
                    {T("Payment option")}
                  </div>
                  <ul className="list-card flex flex-col space-y-[20px]">
                    {cardList.map((item) => (
                      <li
                        key={item.id}
                        className="flex justify-between items-center bg-white rounded-[12px] px-[10px] py-[14px] lg:p-[14px] cursor-pointer"
                        onClick={() =>
                          handleSelectPayment({
                            id: item.id,
                            cvc: "",
                            expiry: trimSpace(item.cardExpiry),
                            name: "",
                            number: `${item.cardNumber}`,
                          })
                        }
                      >
                        <div className="flex justify-start items-center gap-[12px]">
                          <div className="card-img-payment">
                            {getCardIcon(item)}
                          </div>
                          <div className="text-[#222] text-[12px] lg:text-[16px] font-[500]" style={{ fontFamily: 'Roboto' }}>
                            {item.cardNumber}
                          </div>
                        </div>
                        <div className="flex justify-end items-center text-[12px] lg:text-[16px]">
                          <span className="leading-6">{T("Update")}</span>
                          <span>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 18L14.2929 12.7071C14.6262 12.3738 14.7929 12.2071 14.7929 12C14.7929 11.7929 14.6262 11.6262 14.2929 11.2929L9 6"
                                stroke="#222222"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </div>
                      </li>
                    ))}
                    {cardList?.length === 0 ? (
                      <li
                        className="flex justify-between items-center bg-white rounded-[12px] p-[16px] cursor-pointer"
                        onClick={() => {
                          handleSelectPayment();
                        }}
                      >
                        <div className="flex justify-start items-center gap-[12px]">
                          <div className="card-img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M3.5 9.398C3.5 8.37292 3.5 7.86038 3.70266 7.47025C3.87343 7.14149 4.14149 6.87343 4.47025 6.70266C4.86038 6.5 5.37292 6.5 6.398 6.5H17.602C18.6271 6.5 19.1396 6.5 19.5298 6.70266C19.8585 6.87343 20.1266 7.14149 20.2973 7.47025C20.5 7.86038 20.5 8.37292 20.5 9.398V15.602C20.5 16.6271 20.5 17.1396 20.2973 17.5298C20.1266 17.8585 19.8585 18.1266 19.5298 18.2973C19.1396 18.5 18.6271 18.5 17.602 18.5H6.398C5.37292 18.5 4.86038 18.5 4.47025 18.2973C4.14149 18.1266 3.87343 17.8585 3.70266 17.5298C3.5 17.1396 3.5 16.6271 3.5 15.602V9.398Z"
                                stroke="#222222"
                              />
                              <path
                                d="M3.5 10.5L20.5 10.5"
                                stroke="#222222"
                                strokeLinecap="round"
                              />
                              <circle
                                cx="6.5"
                                cy="15.5"
                                r="0.5"
                                fill="#222222"
                              />
                            </svg>
                          </div>
                          <div className="text-[#222] text-[16px] font-[500]">
                            {T("Add a new card")}
                          </div>
                        </div>
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 18L14.2929 12.7071C14.6262 12.3738 14.7929 12.2071 14.7929 12C14.7929 11.7929 14.6262 11.6262 14.2929 11.2929L9 6"
                              stroke="#222222"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ContainerView>
      </Container>

      {isShowModalConfirmTermAndConditionCredix && (
        <ModalTermAndCondition
          onClose={() => setIsShowModalConfirmTermAndConditionCredix(false)}
          onSubmit={() => handleAgreeTermAndConditionCredix()}
          okLoading={isLoadingAgreeTermAndConditionCredix}
        ></ModalTermAndCondition>
      )}
      {isShowModalConfirmTermAndConditionAirwallex && (
          <ModalTermAndConditionAirwallex
              onClose={() => setIsShowModalConfirmTermAndConditionAirwallex(false)}
              onSubmit={() => handleAgreeTermAndConditionAirwallex()}
              okLoading={isLoadingAgreeTermAndConditionAirwallex}
          ></ModalTermAndConditionAirwallex>
      )}
      {isShowModalFeatureNotAvailable && (
        <ModalFeatureNotAvailable
          onClose={() => setIsShowModalFeatureNotAvailable(false)}
          onSubmit={() => setIsShowModalFeatureNotAvailable(false)}
        ></ModalFeatureNotAvailable>
      )}
    </>
  );
};
